import qs from 'qs'

export function getImage(src: string, { modifiers } = {} as Record<string, Record<string, string>>) {
    const [url, params] = src.split('?')
    const urlSearchParams = new URLSearchParams(params)
    const existsParams = Object.fromEntries(urlSearchParams.entries())

    const parameters = qs.stringify(
        { ...existsParams, ...modifiers },
        {
            encode: false,
            arrayFormat: 'comma',
        }
    )

    return {
        url: `${url}?${parameters}`,
    }
}
